module.exports = __webpack_public_path__ + "img/bg5.f925be10.png";